import React, { FunctionComponent } from 'react';

export const MoneyBagIcon: FunctionComponent = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 49 48">
      <path
        fill="#D09BFD"
        stroke="#252B33"
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-width="2"
        d="M29.075 12.988c4.742 3.286 12.908 12.868 12.908 19.982 0 7.2-3.024 13.042-17.65 13.042-14.626 0-17.65-5.838-17.65-13.042 0-7.114 8.166-16.696 12.908-19.982L15.98 6.116a2.088 2.088 0 0 1 .966-2.944 23.628 23.628 0 0 1 14.75 0 2.083 2.083 0 0 1 1 2.952l-3.62 6.864Z"
      />
      <path
        stroke="#252B33"
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-width="2"
        d="m24.65 40.6-8.083-8.436a4.782 4.782 0 0 1 2.617-8.105 4.783 4.783 0 0 1 4.15 1.341l1.32 1.32 1.32-1.32a4.78 4.78 0 1 1 6.761 6.762L24.65 40.6Z"
      />
      <path
        stroke="#252B33"
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-width="2"
        d="M29.075 12.988c4.742 3.286 12.908 12.868 12.908 19.982 0 7.2-3.024 13.042-17.65 13.042-14.626 0-17.65-5.838-17.65-13.042 0-7.114 8.166-16.696 12.908-19.982L15.98 6.116a2.088 2.088 0 0 1 .966-2.944 23.628 23.628 0 0 1 14.75 0 2.083 2.083 0 0 1 1 2.952l-3.62 6.864ZM19.591 12.988h9.484"
      />
      <path
        stroke="#252B33"
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-width="2"
        d="M9.707 15.988c2-3 5-4 9-4 0 0-2-4-8-3"
      />
    </svg>
  );
};
